<!-- @format -->

<template>
	<template v-if="!itemRoutes[0]"> </template>
	<app-link
		v-else-if="!itemRoutes[1]"
		:to="resolvePath(itemRoutes[0].fullPath, itemRoutes[0].query, itemRoutes[0])"
		@click="onClick"
	>
		<el-menu-item
			:style="{ 'padding-left': `${(sidebarLevel + 1) * 12}px` }"
			class="nest-menu"
			:index="resolvePath(itemRoutes[0].meta?.activeMenu || itemRoutes[0].path)"
		>
			<el-icon class="menu-icon">
				<component
					:is="
						itemRoutes[0].meta?.icon === '#' ? '' : svgComps[itemRoutes[0].meta?.icon || ''] || itemRoutes[0].meta?.icon
					"
				/>
			</el-icon>
			<template #title>
				<span class="menu-title" :title="hasTitle(itemRoutes[0].meta?.title)">
					{{ itemRoutes[0].meta?.title }}
				</span>
			</template>
		</el-menu-item>
	</app-link>

	<el-sub-menu
		v-else
		ref="subMenu"
		:style="{ 'padding-left': `${sidebarLevel * 12}px` }"
		:index="resolvePath(itemRoutes[0].meta?.activeMenu || itemRoutes[0].path)"
		popper-append-to-body
		popper-class="sidebar_popper"
	>
		<template v-if="itemRoutes[0].meta" #title>
			<el-icon class="menu-icon">
				<component :is="itemRoutes[0].meta?.icon === '#' ? '' : itemRoutes[0].meta?.icon" />
			</el-icon>
			<span class="menu-title" :title="hasTitle(itemRoutes[0].meta?.title)">
				{{ itemRoutes[0].meta?.title }}
			</span>
		</template>

		<sidebar-item
			v-for="child in itemRoutes[0].children"
			:key="child.fullPath"
			:item="child"
			:base-path="resolvePath(itemRoutes[0].fullPath)"
			:level="sidebarLevel + 1"
			class="nest-menu"
		/>
	</el-sub-menu>
</template>

<script setup lang="ts">
	import { isExternal, getNormalPath, hasTitle } from '@power/utils';
	import { useKeepAliveStoreWithOut } from '@power/runtime-vue3';
	import AppLink from './link.vue';
	import type { Router } from '~/types';
	import { svgComps } from '@/assets/icons/vue';

	interface Props {
		item: Router; // 路由对象
		basePath?: string; // 基础路径
		showOnlyChildren?: boolean;
		level?: number;
	}

	const props = withDefaults(defineProps<Props>(), {
		basePath: '',
	});

	const sidebarLevel: any = computed(() => props.level);

	const keepAliveStore = useKeepAliveStoreWithOut();

	// 返回值: [路由，是否为分组]
	const itemRoutes = computed((): [Router | null, boolean] => {
		const children = props.item.children?.filter((itm) => !itm.hidden) || [];
		return !children.length ? [props.item, false] : [{ ...props.item, children }, true];
	});

	function resolvePath(routePath: string, routeQuery?: string, route?: any) {
		if (isExternal(routePath)) {
			return routePath;
		}
		if (isExternal(props.basePath)) {
			return props.basePath;
		}
		const path = getNormalPath(`${routePath}`);
		// console.log('path2', path);
		if (routeQuery) {
			const query = JSON.parse(routeQuery);
			return { path, query };
		}
		// console.log('route', route);

		if (route?.meta?.routerParam) {
			const params = JSON.parse(route?.meta?.routerParam);
			return { path, query: params };
		}
		return path;
	}

	const onClick = () => {
		keepAliveStore.clear();
	};
</script>
<style scoped lang="scss"></style>
